import React, { Component } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalRegister from '../../Containers/Modal_Register';
import ModalLogin from '../../Containers/Modal_Login';
import Popup from '../../Components/Popup';
import axios from 'axios';
import './style.scss';

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email));
}
const COUNT_TIME = 300;

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      email: false,
      currentCountTime: COUNT_TIME,
      showCountDown: false,
      buttonActive: false,
      title: '',
      body: '',
    };
    this.handlerButtonSubmitPassword =
      this.handlerButtonSubmitPassword.bind(this);
    this.handlerButtonPupup = this.handlerButtonPupup.bind(this);
    this.handleInputEmail = this.handleInputEmail.bind(this);
    this.timer = null;
  }

  handleInputEmail(e) {
    const email = e.target.value;
    this.setState({
      email: email,
      buttonActive: validateEmail(email),
    });
  }

  handlerButtonPupup() {
    this.setState({
      isShowPopup: false,
    });
  }

  handlerButtonSubmitPassword(e) {
    e.preventDefault();
    const { email } = this.state;
    axios
      .post(
        '/api/v1/forgotpassword',
        { email },
        {
          headers: {
            'content-type': 'application/json',
          },
        }
      )
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            isShowPopup: true,
            showCountDown: true,
            currentCountTime: COUNT_TIME,
            title: 'Gửi hướng dẫn thành công.',
            body: `Chúng tôi đã gửi hướng dẫn thay đổi mật khẩu vào <span class="font-weight-bold">${email}</span>, vui lòng kiểm tra hộp thư của bạn.`,
          });
        }
        if (!data.success && data.code == 300) {
          this.setState({
            isShowPopup: true,
            title: 'Gửi hướng dẫn thất bại.',
            body: `Email này <span class="font-weight-bold">${email}</span> của bạn chưa được đăng kí.`,
          });
        } else if (!data.success && data.code == 302) {
          this.setState({
            isShowPopup: true,
            title: 'Gửi hướng dẫn thất bại.',
            body: `Email này <span class="font-weight-bold">${email}</span> của bạn đã gửi hướng đẫn thay đổi mật khẩu, vui lòng kiểm tra hộp thư của bạn.`,
          });
        }
      });
    this.timer = null;
  }

  render() {
    const {
      isShowPopup,
      title,
      body,
      showCountDown,
      currentCountTime,
      buttonActive,
    } = this.state;

    if (showCountDown) {
      if (currentCountTime === 0) {
        clearInterval(this.timer);
        this.setState({
          showCountDown: false,
        });
      }
      if (!this.timer) {
        this.timer = setInterval(() => {
          let count = this.state.currentCountTime - 1;
          this.setState({
            currentCountTime: count,
          });
        }, 1000);
      }
    }

    return (
      <div className='forgot-password'>
        <Header />
        <main>
          <div className='form-sendemail'>
            <h2>Thay đổi mật khẩu</h2>
            <form
              action=''
              method=''
              onSubmit={this.handlerButtonSubmitPassword}
            >
              <div className='form-group'>
                <label>Email</label>
                <input
                  type='text'
                  name='email'
                  placeholder=''
                  onChange={this.handleInputEmail}
                />
              </div>

              <div className='count-down'>
                {showCountDown
                  ? `Bạn có thể gửi lại sau ${`${
                      Math.floor(currentCountTime / 60) <= 0
                        ? ''
                        : `${Math.floor(currentCountTime / 60)}:`
                    }`}${
                      currentCountTime % 60 > 9
                        ? `${currentCountTime % 60}`
                        : `0${currentCountTime % 60}`
                    }s.`
                  : ''}
              </div>
              <button
                type='submit'
                className={`btn_forgotpassword ${
                  buttonActive && !showCountDown ? 'active' : 'disable'
                }`}
                disabled={buttonActive && !showCountDown ? false : true}
              >
                Thay đổi mật khẩu
              </button>
            </form>
          </div>
          {isShowPopup && (
            <Popup
              buttunStyle='btn-danger'
              handle={this.handlerButtonPupup}
              onClosePopup={this.handlerButtonPupup}
              title={title}
              body={body}
              labelButton={'Đồng ý'}
            />
          )}
          <ModalLogin />
          <ModalRegister />
        </main>
        <Footer />
      </div>
    );
  }
}
